module.exports = __webpack_public_path__ + "assets/img/3.c041f1b3.png";